import { render, staticRenderFns } from "./PrintPosFacturaTicketModular2.vue?vue&type=template&id=cb757ffa&scoped=true"
import script from "./PrintPosFacturaTicketModular2.vue?vue&type=script&lang=js"
export * from "./PrintPosFacturaTicketModular2.vue?vue&type=script&lang=js"
import style0 from "./PrintPosFacturaTicketModular2.vue?vue&type=style&index=0&id=cb757ffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb757ffa",
  null
  
)

export default component.exports